<template>
  <tr>
    <td colspan="2">
      <table>
        <tr>
          <td height="5" style="line-height:5px; font-size:0px;">&nbsp;</td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 11px; color: rgb(16, 81, 120); text-align: center; text-transform: uppercase;">
              {{ $t('confirmation.view.terms_short') }}
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 10px; color:#000000;">
              {{ $t('confirmation.view.full_terms') }}:
              <a :href="`https://${website}/terms-and-conditions?utm_source=sps-confirmation&utm_medium=email&utm_campaign=confirmation-email`">
                https://{{ website }}/terms-and-conditions
              </a>
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 10px; color:#000000; text-transform: uppercase;">
              1. {{ $t('confirmation.view.parking_req') }}
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              {{ $t('confirmation.view.must_ensure') }}
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 10px; color:#000000; text-transform: uppercase;">
              2. {{ $t('confirmation.view.booking_agent') }}
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              {{ $t('confirmation.view.is_an_agent') }}
           </font>
          </td>
        </tr>
        <tr v-for="(item, key) in booking.details.bookings.airportparking" :key="key">
          <td>
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              <a :href="`https://legacy.skyparksecure.com/product-terms/${item.product.product_tcs}`">
                https://{{ website }}/product-terms/{{ item.product.product_tcs }}
              </a>
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 10px; color:#000000; text-transform: uppercase;">
              3. {{ $t('confirmation.view.cancellation_policy') }}
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              {{ $t('confirmation.view.non_applicable') }}:
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000; text-transform: uppercase;">
              3.1 {{ $t('confirmation.view.direct_cancellation') }}
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              3.2 {{ $t('confirmation.view.please_send') }}
              <a href="mailto:info@skyparksecure.com">info@skyparksecure.com</a> 
              quoting your booking reference number. Please note that cancellation requests can only be accepted within office hours and are subject to our notice periods (see 3.5).
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              3.3 Any clients booking where they have not complied with on screen booking requirements (e.g. printed off their voucher etc.) and who have been unable to park, will not be subject to a refund.
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              3.3 Any clients booking where they have not complied with on screen booking requirements (e.g. printed off their voucher etc.) and who have been unable to park, will not be subject to a refund.
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              3.4 No refunds are available for unused part stays.
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              3.5 Refund Notice Periods:
              <br />- Edinburgh Flying Scot - Less than 14 days notice - no refund
              <br />- Edinburgh Low Cost Park &amp; Ride - Less than 14 days notice - no refund
              <br />- Manchester SkyPark Indoor - Less than 14 days notice - no refund
              <br />- Edinburgh ParkanFly - Park &amp; Ride/Meet &amp; Greet - Less than 14 days - no refund.
              <br />- All other car parks: - Less than 72 hours notice - no refund
              <br />All cancelled bookings are subject to a &pound;10.00 charge. *Except on certain promotional offers which are non-refundable. Where applicable this will be stated in the car park description/information.
              <br />
              <br />All Bookings Fees and SMS charges are non-refundable
            </font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font
              style="font-weight: normal; font-size: 8px; color:#000000;"
            >3.6 Duplicate Bookings - In the event of a client making a duplicate booking for the same stay/vehicle and client and do not contact us within 28 days of their return will incur the full cost of that booking.</font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font
              style="font-weight: normal; font-size: 8px; color:#000000;"
            >3.7 With every effort being made to ensure clients' receive the information pertaining to their booking. If for any reason a client fails to utilize the booked space and adequate notice is not given (72 hours) will regretfully receive no refund.</font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              3.8 CANCELLATION COVER (Not applicable to non-cancellable / non-amendable products or booked within 24 hours of arrival time):
              <br />a) Should a client wish to cancel they must do so at least 24 hours prior to their departure date in order to be eligible, those who cancel after this time will be subject to our normal conditions listed above.
              <br />b) Cancellation Cover does not apply for bookings made the same day, booked for the following day or in certain products where stated.
              <br />Please note that cancellation requests can only be accepted during our office hours and are subject to our notice period (see 3.5).
            </font>
          </td>
        </tr>
        <tr>
          <td>
            <font style="font-weight: bold; font-size: 10px; color:#000000;">4. COMPLAINTS</font>
          </td>
        </tr>
        <tr>
          <td style="line-height: 0.7;">
            <font style="font-weight: normal; font-size: 8px; color:#000000;">
              Whilst we endeavour to provide the perfect service, we understand that incidents may occur. Should you encounter any issues please do not hesitate to contact us. All complaints must be made to the service provider (car park) in person at the time of the occurrence, and then followed up in writing (email or letter)
              <a href="mailto:info@skyparksecure.com">info@skyparksecure.com</a>, which must be received by our company within 10 days of your return in order to be valid. As most complaints require investigation with both the service provider and their staff we apologize that although we will happily discuss your complaint with you we are unable to resolve your complaint via the telephone and will require it in writing.
              <br />
              <br />Skyparksecure Ltd, 6th Floor Olympic House, Manchester Airport, Manchester, England, M90 1QX
              <br />
              <br />
            </font>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</template>

<script>
export default {
  name: "confirmation-view-terms",
  props: {
    website: { type: String },
    booking: { type: Object, default: () => {} }
  }
};
</script>